import {
  FormTemplateFieldConditionalRule,
  FormTemplateFieldTypes,
} from 'mapistry-shared';
import React from 'react';
import { EditBooleanFieldForm } from './EditBooleanFieldForm';
import { EditExplanationAreaFieldForm } from './EditExplanationAreaFieldForm';
import { EditLocationFieldForm } from './EditLocationFieldForm';
import { EditSelectFieldForm } from './EditSelectFieldForm';
import {
  BaseEditGenericFieldFormProps,
  EditGenericFieldForm,
} from './GenericFieldForm/EditGenericFieldForm';

type EditFieldFormProps = {
  fieldType: FormTemplateFieldTypes;
  isConditionTriggerField: boolean;
  conditionalRules?: FormTemplateFieldConditionalRule[];
} & BaseEditGenericFieldFormProps;

export const EditFieldForm = (props: EditFieldFormProps) => {
  const {
    fieldType,
    isConditionTriggerField,
    conditionalRules,
    ...genericEditFormProps
  } = props;
  const { prefix } = genericEditFormProps;

  switch (fieldType) {
    case FormTemplateFieldTypes.BOOLEAN:
      return <EditBooleanFieldForm {...genericEditFormProps} />;
    case FormTemplateFieldTypes.EXPLANATION_AREA:
      return <EditExplanationAreaFieldForm prefix={prefix} />;
    case FormTemplateFieldTypes.SINGLE_LOCATION:
    case FormTemplateFieldTypes.MULTI_LOCATION:
      return <EditLocationFieldForm {...genericEditFormProps} />;
    case FormTemplateFieldTypes.SINGLE_SELECT:
    case FormTemplateFieldTypes.SINGLE_SELECT_WITH_FREE_FORM:
    case FormTemplateFieldTypes.MULTI_SELECT:
    case FormTemplateFieldTypes.MULTI_SELECT_WITH_FREE_FORM:
      return (
        <EditSelectFieldForm
          isConditionTriggerField={isConditionTriggerField}
          conditionalRules={conditionalRules}
          {...genericEditFormProps}
        />
      );
    default:
      return <EditGenericFieldForm {...genericEditFormProps} />;
  }
};
